export default "/_next/static/src/lib/assets/rive/ff81c4933500c95f8f06741eb0c6c828.riv";